var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.015625,
    y: 0.304688,
    width: 56.6202,
    height: 56.6202,
    rx: 10,
    fill: "#F6F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2471 36.1736V31.5146H21.9375V36.1736L28.0923 41.4982L34.2471 36.1736Z",
    fill: "#E6AF78",
    fillOpacity: 0.56
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7629 38.3532L35.3006 36.4153C35.1727 36.386 35.0552 36.3363 34.9452 36.2761L28.0912 40.1673L21.5045 36.0879C21.334 36.2441 21.1223 36.3602 20.8819 36.4154L12.4195 38.3532C11.1838 38.6362 10.3105 39.7093 10.3105 40.9448V46.1575C10.3105 46.8928 10.9229 47.4887 11.6783 47.4887H44.504C45.2594 47.4887 45.8717 46.8927 45.8717 46.1575V40.9448C45.8718 39.7092 44.9986 38.6361 43.7629 38.3532Z",
    fill: "#577CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9375 31.5147V36.4303C29.6909 39.1491 34.2471 32.3447 34.2471 32.3447V31.5146H21.9375V31.5147Z",
    fill: "#D29B6E",
    fillOpacity: 0.34
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2031 16.208L19.7991 28.9679C19.8547 30.16 20.4553 31.2654 21.4361 31.9813L24.2637 34.0454C24.974 34.5637 25.8378 34.8441 26.7257 34.8441H29.4612C30.349 34.8441 31.2128 34.5638 31.9231 34.0454L34.7508 31.9813C35.7316 31.2653 36.3321 30.16 36.3878 28.9679L36.9837 16.208H19.2031Z",
    fill: "#F7DECE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0419 18.8703C28.7774 18.8703 32.8805 18.2048 33.8538 16.208H19.2031L19.7991 28.9679C19.8547 30.16 20.4553 31.2653 21.4361 31.9813L24.2638 34.0454C24.9741 34.5637 25.8379 34.8441 26.7257 34.8441H28.0935C26.7257 34.8441 23.9902 32.1818 23.9902 28.8539C23.9902 27.2263 23.9902 22.8638 23.9902 20.867C23.9902 20.2015 24.6741 18.8703 26.0419 18.8703Z",
    fill: "#F2D4B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.331 43.1682L10.8996 39.2939C10.5282 39.7516 10.3105 40.3274 10.3105 40.9439V46.1566C10.3105 46.8919 10.9229 47.4878 11.6783 47.4878H16.4654V45.6439C16.4653 44.6994 16.0529 43.7993 15.331 43.1682Z",
    fill: "#7F9BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8512 43.1682L45.2826 39.2939C45.6539 39.7516 45.8716 40.3274 45.8716 40.9439V46.1566C45.8716 46.8919 45.2593 47.4878 44.5039 47.4878H39.7168V45.6439C39.7168 44.6994 40.1292 43.7993 40.8512 43.1682Z",
    fill: "#7F9BFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8383 34.6924L28.0892 40.1676C28.0892 40.1676 26.3386 41.0277 24.1783 42.7612C23.7327 43.1188 23.0586 42.974 22.8196 42.4622L19.8828 36.1742L20.8119 34.818C21.0431 34.4802 21.5284 34.4209 21.8383 34.6924Z",
    fill: "#7F9BFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3407 34.6924L28.0898 40.1676C28.0898 40.1676 29.8404 41.0277 32.0007 42.7612C32.4463 43.1188 33.1204 42.974 33.3594 42.4622L36.2962 36.1742L35.3672 34.818C35.1359 34.4802 34.6506 34.4209 34.3407 34.6924Z",
    fill: "#7F9BFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2344 11.7983L32.8755 16.2077C35.802 16.7773 36.2238 21.2473 36.2845 22.5239C36.2955 22.7557 36.3715 22.9794 36.5007 23.1743L37.6173 24.8601C37.6173 24.8601 37.2351 22.073 38.985 20.2011C38.985 20.2011 39.586 9.13592 32.2344 11.7983Z",
    fill: "#404040"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8563 10.6052L20.8678 11.2777C16.2945 14.564 17.1492 20.2006 17.1492 20.2006C18.5169 21.5317 18.5169 24.8596 18.5169 24.8596L19.8847 23.5285C19.8847 23.5285 19.3568 19.6832 21.9362 18.2039C24.3298 16.8311 26.4241 17.5383 28.5612 17.5383C34.2886 17.5383 35.8915 15.4376 35.6137 12.8793C35.4699 11.5556 33.3903 8.79814 28.0911 8.88583C25.9525 8.9212 21.9364 9.5514 19.8563 10.6052Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientsIcon);
export default __webpack_public_path__ + "static/media/patients_icon.5151843af2536c2f8f9c37b4a7064430.svg";
export { ForwardRef as ReactComponent };